import * as React from 'react';
import * as ReactRedux from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import * as AppConfig from './app.config';
import * as ReactRouter from 'react-router-dom';
import * as ReactRouterRedux from 'react-router-redux';
import { IntlProvider } from 'react-intl';
import Login from '../auth/login';
import Dashboard from '../dashboard/Dashboard';
import AdminDashboard from '../admin/admin.dashboard';
import EmailBlast from '../admin/EmailBlast';
import Members from '../members/Members';
import Staff from '../staff/Staff';
import Programs from '../programs/Programs';
import Package from '../mms-package/Package';
import Report from '../mms-package/Report';
import Leads from '../leads/Leads';
import EmailTemplate from '../emailTemplate/EmailTemplate';
import { paths } from './app.routes';
import AttendanceCheckIn from '../attendance/AttendanceCheckIn';
import AttendanceHistory from '../attendance/AttendanceHistory';
import AccountMyInfo from '../account/MyInfo';
import BusinessInfo from '../account/BusinessInfo';
import PaymentHistory from '../payments/PaymentHistory';
import PaymentList from '../payments/PaymentList';
import AdminBusiness from '../admin/admin.business';
import NotFound from '../commons/not.found';
import InternalServerError from '../commons/internal.server.error';
import SignupStepper from '../admin/signup.stepper';
import PosSale from '../pos/PosSale';
import PosHistory from '../pos/PosHistory';
import PosSaleResult from '../pos/PosSaleResult';
import LockedAccount from '../admin/LockedAccount';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { mmsPersistor } from './app.config';
import { MmsColor } from './app.const';
import EmailVerifiedComponent from '../commons/EmailVerifiedComponent';
import EmailNotVerifiedComponent from '../commons/EmailNotVerifiedComponent';
import PosSaleNoLogin from '../pos/PosSaleNoLogin';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import ServiceAgreementComponent from '../policies/ServiceAgreementComponent';
import ProgramDetail from '../programs/ProgramDetail';
import EmailResult from 'src/emailTemplate/EmailResult';

const mmsMuiTheme = getMuiTheme({
  palette: {
    primary1Color: MmsColor.MmsYellow,
    primary2Color: MmsColor.MmsYellow,
    accent1Color: MmsColor.MmsDarkGrey,
    accent2Color: MmsColor.MmsLightGrey
  },
  appBar: {
    textColor: MmsColor.MmsDarkGrey
  },
  checkbox: {
    checkedColor: MmsColor.MmsDarkGrey,
    requiredColor: MmsColor.MmsDarkGrey
  },
  datePicker: {
    headerColor: MmsColor.MmsYellow,
    selectColor: MmsColor.MmsDarkGrey,
    textColor: MmsColor.MmsDarkGrey
  },
  floatingActionButton: {
    iconColor: MmsColor.MmsDarkGrey
  },
  menuItem: {
    selectedTextColor: MmsColor.MaterialLightRed
  },
  radioButton: {
    checkedColor: MmsColor.MmsDarkGrey,
    requiredColor: MmsColor.MmsDarkGrey
  },
  raisedButton: {
    primaryTextColor: MmsColor.MmsDarkGrey
  },
  flatButton: {
    primaryTextColor: MmsColor.MmsDarkGrey,
    secondaryTextColor: MmsColor.MaterialLightRed
  },
  textField: {
    floatingLabelColor: MmsColor.MmsTextLightGrey,
    focusColor: MmsColor.MmsTextLightGrey
  },
  timePicker: {
    accentColor: MmsColor.MmsDarkGrey,
    headerColor: MmsColor.MmsYellow,
    textColor: MmsColor.MmsDarkGrey
  },
  tabs: {
    backgroundColor: MmsColor.White,
    textColor: MmsColor.MmsTextLightGrey,
    selectedTextColor: MmsColor.Black
  }
});

type Props = {};

class App extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props);
  }

  render() {
    /* tslint:disable */
    return (
      <PersistGate persistor={mmsPersistor}>
        <MuiThemeProvider muiTheme={mmsMuiTheme}>
          <IntlProvider locale="en">
            <ReactRedux.Provider store={AppConfig.mmsStore}>
              <ReactRouterRedux.ConnectedRouter history={AppConfig.history}>
                <ReactRouter.Switch>
                  <ReactRouter.Route exact={true} path='/' component={Login as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.dashboard} component={Dashboard as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.adminDashboard} component={AdminDashboard as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.adminBusiness} component={AdminBusiness as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.adminLockedAccount} component={LockedAccount as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.adminAccountRegistration} component={SignupStepper as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.adminEmailBlast} component={EmailBlast as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.programs} component={Programs as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.packages} component={Package as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.reports} component={Report as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.leads} component={Leads as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.emailTemplate} component={EmailTemplate as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.emailResult} component={EmailResult as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.programDetail} component={ProgramDetail as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.members} component={Members as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.staffs} component={Staff as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.login} component={Login as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.attendancesCheckIn} component={AttendanceCheckIn as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.attendancesHistory} component={AttendanceHistory as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.myInfo} component={AccountMyInfo as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.businessInfo} component={BusinessInfo as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.paymentList} component={PaymentList as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.paymentHistory} component={PaymentHistory as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.posSale} component={PosSale as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.posSaleResult} component={PosSaleResult as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.posHistory} component={PosHistory as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.internalServerError} component={InternalServerError as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.emailVerification} component={EmailVerifiedComponent as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.emailVerificationFail} component={EmailNotVerifiedComponent as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.failedPayment} component={PosSaleNoLogin as React.ComponentClass<any>} />
                  <ReactRouter.Route exact={true} path={paths.serviceAgreement} component={ServiceAgreementComponent as React.ComponentClass<any>} />
                  <ReactRouter.Route path={'/*'} component={NotFound as React.ComponentClass<any>} />
                </ReactRouter.Switch>
              </ReactRouterRedux.ConnectedRouter>
            </ReactRedux.Provider>
          </IntlProvider>
        </MuiThemeProvider>
      </PersistGate>
    );
    /* tslint:enable */
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.tsx